<template>
  <div class="eventos-busqueda-formulario ">
 <div class=" disableSearch">
      <p class="titulo">Búsqueda de Eventos</p>
  
      <form id="buscador" ref="buscador" class="mt-3">
        <div class="form-group">
          <label for="categoria-input">Categoría</label>
          <SelectVue @input="getCategoria" />
        </div>
  
        <div class="form-group mt-1">
          <label for="categoria-input">Fecha de inicio</label>
          <date-pick
            id="categoria-input2"
            v-model="fecha1"
            format="DD/MM/YYYY"
          ></date-pick>
        </div>
        <div class="form-group mt-1">
          <label for="categoria-input">Fecha de finalización</label>
          <date-pick
            id="categoria-input3"
            v-model="fecha2"
            format="DD/MM/YYYY"
          ></date-pick>
        </div>
        <a href="#" class="btn btn-principal mt-3" v-on:click.prevent="buscar"
          >Buscar</a
        >
      </form>
 </div>
 
     <div class="alert alert-info mt-5" role="alert">
       Por el momento la búsqueda se encuentra deshabilitada, disculpe las molestias.
    </div>

  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePick from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";

import SelectVue from "../components/selectVue";

export default {
  components: { DatePick, SelectVue },
  name: "buscador",

  data: () => ({
    fecha1: "",
    fecha2: "",
    resp: [],
    idCategoria: null,
    url: "https://eservicios2.aguascalientes.gob.mx/geaws/api/gea/eve/ws/aut/"
  }),
  watch: {
    url: function(val) {
      this.url = val;
    }
  },
  methods: {
    buscar: function(elem) {
      const that = this;

      that.idCategoria = that.idCategoria !== null ? that.idCategoria : "";

      let finicio =
        this.fecha1 !== undefined
          ? new moment(this.fecha1, "DD/MM/YYYY").utc().valueOf()
          : "";
      let ffin =
        this.fecha2 !== undefined
          ? new moment(this.fecha2, "DD/MM/YYYY")
              .utc()
              .endOf("day")
              .valueOf()
          : "";

      that.url =
        "https://eservicios2.aguascalientes.gob.mx/geaws/api/gea/eve/ws/aut/" +
        that.idCategoria +
        "&fechaInicio=" +
        finicio +
        "&fechaFin=" +
        ffin;

      console.log("Categoria: " + that.idCategoria);
      console.log("fecha inicio: " + finicio);
      console.log("fecha fin: " + ffin);
      console.log("url: " + that.url);

      this.$emit("clicked", that.url);
    },

    getCategoria(id) {
      this.idCategoria = id;
    },
    formatDate(v, fdate) {
      if (v) {
        return moment(String(v)).format(fdate);
      }
    }
  }
};
</script>

<style scoped>
.disableSearch > * {
  pointer-events: none;
  opacity: 0.5;
}
</style>
